import { getUserCurrencySymbol } from "utils/AuthUtil";

export const getTablePriceFieldValue = (price) => {
  return `${getUserCurrencySymbol()} ${price?.toFixed(2)}`;
};
